import React from 'react';
import { Switch } from '@producer/ui-kit';

import styles from './plan-cycle-switch.module.scss';
const cycles = {
  month: false,
  year: true,
};

type PlanCycleSwitchProps = {
  cycle: 'month' | 'year';
  setCycle: (cycle: 'month' | 'year') => void;
};

export const PlanCycleSwitch: React.FC<PlanCycleSwitchProps> = ({ cycle = 'year', setCycle }) => {
  const handleToggle = (value: boolean) => {
    if (value) {
      setCycle('year');
    } else {
      setCycle('month');
    }
  };

  return (
    <div className={styles['container']}>
      <p>Monthly</p>

      <Switch onToggle={handleToggle} isToggled={cycles[cycle]} size="medium" grayscale />

      <p>Yearly</p>
    </div>
  );
};
